import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WrapTextIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wrap_text"}/>
}
